document.addEventListener('click', (event) => {

  const sizeButton = event.target.closest(
    '.card-size-picker__button'
  );

  if (!sizeButton || sizeButton.disabled) {
    return;
  }

  const picker = sizeButton.closest(
    '.card-size-picker'
  );

  if (!picker) {
    return;
  }


  // Remove previous selection
  picker
    .querySelectorAll('.card-size-picker__button')
    .forEach((button) => {
      button.classList.remove('is-selected');
    });


  // Select clicked size
  sizeButton.classList.add('is-selected');


  // Set variant ID
  const variantInput =
    picker.querySelector(
      '[ref="variantId"]'
    );

  if (!variantInput) {
    console.error(
      'Variant input not found'
    );

    return;
  }


  variantInput.value =
    sizeButton.dataset.variantId;

  variantInput.disabled = false;


  // Enable Add to Cart button
  const addButton =
    picker.querySelector(
      '.card-size-picker__add'
    );

  if (addButton) {
    addButton.disabled = false;
    addButton.removeAttribute('aria-disabled');
  }

});

document.addEventListener('click', (event) => {
  const addButton = event.target.closest(
    '.card-size-picker__add'
  );

  if (!addButton) {
    return;
  }

  setTimeout(() => {
    const cartDrawer = document.querySelector(
      'theme-drawer#cart-drawer'
    );

    if (cartDrawer) {
      cartDrawer.open = true;
    }
  }, 300);
});